import { Component, ChangeDetectionStrategy } from "@angular/core";

@Component({
    selector: "vds-label, [vds-label]",
    template: "<ng-content></ng-content>",
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ["./label.component.css"]
})
export class VdsLabelComponent {}
